import React, { useEffect } from "react";
import CustomInput from "../../../components/CustomInput/CustomInput";
import StatusSelect from "../../../components/CustomSelect/StatusSelect";
import { Controller, useForm } from "react-hook-form";
import { getAllBrands } from "../../../redux/CarsManagement/Brands/brandsSlice";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import LoadingOverlay from "../../../helpers/LoadingOverlay/LoadingOverlay";
import { searchBrandTypes } from "../../../redux/CarsManagement/BrandTypes/brandTypesSlice";

function BrandTypesPanelSearch() {
  const dispatch = useDispatch();
  const { searchCriteria, isLoading } = useSelector(
    (state) => state.brandTypes
  );

  const { allBrands, isLoading: brandsLoading } = useSelector(
    (state) => state.brands
  );

  // Options For Select
  const brandOptions = allBrands.map((brand) => ({
    value: brand.id,
    label: brand.nameAr,
  }));

  const {
    formState: { errors, isDirty },
    handleSubmit,
    reset,
    control,
  } = useForm({
    defaultValues: searchCriteria,
  });

  useEffect(() => {
    reset(searchCriteria);
  }, [searchCriteria]);

  // Get All Brands
  useEffect(() => {
    dispatch(getAllBrands());
  }, []);

  const searchCar = (data) => {
    dispatch(searchBrandTypes(data));
  };

  return brandsLoading ? (
    <LoadingOverlay />
  ) : (
    <form
      className="uk-grid-small uk-child-width-1-2"
      uk-grid=""
      onSubmit={handleSubmit(searchCar)}
    >
      <div>
        <label className="uk-form-label uk-text-gray uk-text-bold">الإسم</label>
        <div className="uk-form-controls uk-margin-small-top">
          <CustomInput
            control={control}
            name="nameAr"
            error={errors.nameAr}
            required={false}
          />
        </div>
      </div>
      <div>
        <label className="uk-form-label uk-text-gray uk-text-bold">
          الماركة
        </label>
        <div className="uk-form-controls uk-margin-small-top">
          <Controller
            name="brand_id"
            control={control}
            render={({ field }) => (
              <CustomSelect
                placeholder={"اختر مُصنع"}
                field={field}
                options={brandOptions}
                error={errors.brand_id}
              />
            )}
          />
        </div>
      </div>
      <div>
        <label className="uk-form-label uk-text-gray uk-text-bold">
          الحالة
        </label>
        <div className="uk-form-controls uk-margin-small-top">
          <Controller
            name="status"
            control={control}
            render={({ field }) => (
              <StatusSelect
                field={field}
                error={errors.status}
                allowClear
                allowAll
              />
            )}
          />
        </div>
      </div>
      <div>
        <div className="uk-position-relative uk-width-1-1 uk-height-1-1">
          <button
            className="uk-button uk-button-secondary uk-border-rounded uk-position-bottom"
            disabled={!isDirty}
          >
            بحث
          </button>
        </div>
      </div>
    </form>
  );
}

export default BrandTypesPanelSearch;
